import { Component } from 'react';
import ReactDOM from 'react-dom';

class Portal extends Component<{children}, { portalEl: Element }> {
    state = {
        portalEl: document.createElement('div'),
    };

    componentDidMount(): void {
        document.body.appendChild(this.state.portalEl);
    }

    componentWillUnmount(): void {
        document.body.removeChild(this.state.portalEl);
    }

    render(): JSX.Element {
        return ReactDOM.createPortal(this.props.children, this.state.portalEl);
    }
}

export default Portal;
